export default "__VITE_ASSET__BEwhGJaX__"